export { BaseLibraryIconSvg as default } from '@packages/shared-ui';
